module.exports = __webpack_public_path__ + "static/benefit-online-honor-1e8a786916c2eb98b5aaf5b98cdfd5ae.png";